import { Helmet } from 'react-helmet';
import pageStyles from '../styles/page-common.module.css';

function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact | LingoLeaf</title>
        <meta name="description" content="Get in touch with the LingoLeaf team for support, feedback, or inquiries about our language-learning platform." />
      </Helmet>
      <div className={pageStyles.styledPage}>
        <h1>Contact</h1>
        <p>Send an email to <strong>contact "at" lingoleaf.io</strong> with any queries or feedback, or to report any inaccurate or inappropriate content.</p>
        <p>We try to reply to everyone within a couple of business days, max.</p>
      </div>
    </>
  );
}

export default Contact;